import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function CustomSection({ children }: Props) {
  return (
    <div className="w-full p-6 bg-white rounded border border-[#e9eff6] border-solid">
      {children}
    </div>
  );
}
